export const SIGNATURE_LAYOUT_DEFAULTS = {
  receipt: { x: 0, y: 0, width: 100 },
  expense: { x: 0, y: 0, width: 80 },
  purchase_order: { x: 0, y: 0, width: 80 },
  quote: { x: 0, y: 0, width: 70 },
  delivery_note: { x: 0, y: 0, width: 80 },
  pending_delivery: { x: 0, y: 0, width: 80 },
};

const clamp = (value, fallback, min, max) => {
  const number = Number(value);
  return Number.isFinite(number) ? Math.min(Math.max(number, min), max) : fallback;
};

export const parseSignatureLayouts = value => {
  if (!value) return {};
  if (typeof value === 'object') return value;
  try { return JSON.parse(value); } catch (_) { return {}; }
};

export const normalizeSignatureLayout = (value, documentType) => {
  const defaults = SIGNATURE_LAYOUT_DEFAULTS[documentType] || SIGNATURE_LAYOUT_DEFAULTS.receipt;
  return {
    x: clamp(value?.x, defaults.x, -120, 120),
    y: clamp(value?.y, defaults.y, -100, 100),
    width: clamp(value?.width, defaults.width, 40, 180),
  };
};

export const getCompanySignatureLayout = (company, documentType) => {
  const layouts = parseSignatureLayouts(company?.signature_layout);
  return normalizeSignatureLayout(layouts?.[documentType], documentType);
};

export const isValidPdfImage = image => (
  typeof image === 'string' && image.trim().length > 0
);

export const createSignatureImageNode = (image, layout, documentType, options = {}) => {
  if (!isValidPdfImage(image)) return null;

  const resolvedLayout = normalizeSignatureLayout(layout, documentType);
  const {
    alignment = 'center',
    margin = [0, 0, 0, 0],
    ...nodeOptions
  } = options;

  return {
    image,
    width: resolvedLayout.width,
    alignment,
    margin,
    relativePosition: {
      x: resolvedLayout.x,
      y: resolvedLayout.y,
    },
    ...nodeOptions,
  };
};
